export const LOGIN_REQUEST = '[AUTH] LOGIN_REQUEST'
export const LOGIN_SUCCESS = '[AUTH] LOGIN_SUCCESS'
export const LOGIN_FAILED = '[AUTH] LOGIN_FAILED'

export const LOGOUT_REQUEST = '[AUTH] LOGOUT_REQUEST'
export const LOGOUT_SUCCESS = '[AUTH] LOGOUT_SUCCESS'
export const LOGOUT_FAILED = '[AUTH] LOGOUT_FAILED'

export const FORGOT_PASSWORD_REQUEST = '[AUTH] FORGOT_PASSWORD_REQUEST'
export const FORGOT_PASSWORD_SUCCESS = '[AUTH] FORGOT_PASSWORD_SUCCESS'
export const FORGOT_PASSWORD_FAILED = '[AUTH] FORGOT_PASSWORD_FAILED'

export const RESET_PASSWORD_REQUEST = '[AUTH] RESET_PASSWORD_REQUEST'
export const RESET_PASSWORD_SUCCESS = '[AUTH] RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAILED = '[AUTH] RESET_PASSWORD_FAILED'

export const GET_PERSONAL_INFO_REQUEST = '[AUTH] GET_PERSONAL_INFO_REQUEST'
export const GET_PERSONAL_INFO_SUCCESS = '[AUTH] GET_PERSONAL_INFO_SUCCESS'
export const GET_PERSONAL_INFO_FAILED = '[AUTH] GET_PERSONAL_INFO_FAILED'

export const CHANGE_PERSONAL_INFO = '[AUTH] CHANGE_PERSONAL_INFO';

export const COLLAPSE_FORGOT_PASSWORD_FORM = '[AUTH] COLLAPSE_FORGOT_PASSWORD_FORM'
export const COLLAPSE_RESET_PASSWORD_FORM = '[AUTH] COLLAPSE_RESET_PASSWORD_FORM'

export const GET_USER_PAGE_REFRESH_REQUEST = '[AUTH] GET_USER_PAGE_REFRESH_REQUEST'
export const GET_USER_PAGE_REFRESH_SUCCESS = '[AUTH] GET_USER_PAGE_REFRESH_SUCCESS'